/**
 * reCAPTCHA bilgilendirme metni.
 *
 * NEDEN VAR: sağ alttaki Google rozeti `index.css` içinde gizlendi. Google'ın
 * kullanım şartları rozetin gizlenmesine izin veriyor, ancak bu durumda
 * reCAPTCHA'nın kullanıldığı formda gizlilik/şartlar bağlantılarını içeren
 * görünür bir metin bulunmasını zorunlu kılıyor. Bu bileşen o metni sağlar.
 *
 * Anahtar yapılandırılmamışsa (REACT_APP_RECAPTCHA_SITE_KEY boş) reCAPTCHA
 * çalışmıyordur → metin de gösterilmez.
 */
import { isRecaptchaConfigured } from "../lib/recaptcha";

export default function RecaptchaNotice({ className = "" }) {
  if (!isRecaptchaConfigured()) return null;
  return (
    <p
      className={`text-[10px] leading-relaxed text-muted-foreground ${className}`}
      data-testid="recaptcha-notice"
    >
      Bu site reCAPTCHA ile korunmaktadır ve Google{" "}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-foreground"
      >
        Gizlilik Politikası
      </a>{" "}
      ve{" "}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-foreground"
      >
        Hizmet Şartları
      </a>{" "}
      geçerlidir.
    </p>
  );
}
